import { useCallback, useState } from "react";
import { ConditionData } from "@covertree/types";
import { SetModalCondition } from "./types";

/** State of the modal opened by the UW conditions that have sub-questions. */
const useUwModal = () => {
  const [hasAnswerChanged, setHasAnswerChanged] = useState<boolean>(false);
  const [modalConditionData, setModalConditionData] =
    useState<ConditionData | null>(null);

  const setModalCondition = useCallback<SetModalCondition>(
    (condition, hasAnswerChanged = false) => {
      setModalConditionData(condition);
      setHasAnswerChanged(hasAnswerChanged);
    },
    []
  );

  return { modalConditionData, hasAnswerChanged, setModalCondition };
};

export { useUwModal };
